// extracted by mini-css-extract-plugin
module.exports = {"refurbished-B":"B_refurbished-B__zY3aY"};